(() => {
  const PRODUCT_SELECTOR = '[data-product-media-gallery]';
  const FEATURED_IMAGE_SELECTOR = '[data-featured-image-wrapper]';
  const THUMBNAILS_SELECTOR = '[data-thumbnails] [data-thumb-src]';

  const MOBILE_SECTION_SELECTOR = '[data-featured-product-section]';
  const SWIPER_SELECTOR = '[data-swiper]';
  const NEXT_BUTTON_SELECTOR = '[data-next-swiper]';
  const PREV_BUTTON_SELECTOR = '[data-prev-swiper]';
  const CURR_IMAGE_NUMBER_SELECTOR = '[data-current-image-number]';

  const prepareVideo = (video) => {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  };

  const safePlay = (video, callback) => {
    if (!video) return;

    prepareVideo(video);

    const tryPlay = () => {
      const playPromise = video.play();

      if (playPromise?.then) {
        playPromise
          .then(() => {
            if (callback) callback();
          })
          .catch(() => {});
      } else if (callback) {
        callback();
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }
  };

  const setIcon = (scope, isPlaying) => {
    const icon = scope?.querySelector('[data-pause-button] use');
    if (!icon) return;

    icon.setAttribute('href', isPlaying ? '#pause-video' : '#play-video');
  };

  const initThumbnails = () => {
    const section = document.querySelector(PRODUCT_SELECTOR);
    if (!section) return;

    const featured = section.querySelector(FEATURED_IMAGE_SELECTOR);
    if (!featured) return;

    section.querySelectorAll(THUMBNAILS_SELECTOR).forEach((element) => {
      const isVideo = element.hasAttribute('data-video-wrapper');

      element.addEventListener('click', () => {
        if (isVideo) {
          featured.innerHTML = `
            <video
              class="v:w-full v:h-full v:object-cover"
              poster="${element.getAttribute('data-thumb-src')}"
              src="${element.getAttribute('data-video-src')}"
              preload="auto"
              autoplay
              muted
              playsinline
              webkit-playsinline
            ></video>

            <svg 
              data-pause-button
              class="v:cursor-pointer v:absolute v:bottom-5 v:left-5" 
              width="30" 
              height="30"
            >
              <use href="#pause-video"></use>
            </svg>
          `;

          const video = featured.querySelector('video');

          safePlay(video, () => {
            setIcon(featured, true);
          });

          video?.addEventListener('ended', () => {
            setIcon(featured, false);
          });
        } else {
          featured.innerHTML = `
            <img
              src="${element.getAttribute('data-thumb-src')}"
              alt="featured product image"
              class="v:w-auto v:h-full v:aspect-square v:rounded-2xl v:object-cover"
            >
          `;
        }

        section
          .querySelectorAll(THUMBNAILS_SELECTOR)
          .forEach((i) => i.classList.remove('selected'));

        element.classList.add('selected');
      });
    });
  };

  const initSwipers = () => {
    const section = document.querySelector(MOBILE_SECTION_SELECTOR);
    if (!section) return;

    const swiperEl = section.querySelector(SWIPER_SELECTOR);
    if (!swiperEl) return;

    const nextEl = section.querySelector(NEXT_BUTTON_SELECTOR);
    const prevEl = section.querySelector(PREV_BUTTON_SELECTOR);
    const currentDisplay = section.querySelector(CURR_IMAGE_NUMBER_SELECTOR);

    const updateCurrent = (swiper) => {
      if (currentDisplay) {
        currentDisplay.textContent = swiper.realIndex + 1;
      }
    };

    const playActiveSlideVideo = () => {
      const activeSlide = swiperEl.querySelector('.swiper-slide-active');
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector('video');

      swiperEl.querySelectorAll('video').forEach((video) => {
        if (video !== activeVideo) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
          const slide = video.closest('.swiper-slide');
          setIcon(slide, false);
        }
      });

      if (!activeVideo) return;
      if (activeSlide.dataset.userPaused === 'true') return;

      safePlay(activeVideo, () => {
        setIcon(activeSlide, true);
      });

      activeVideo.addEventListener(
        'ended',
        () => {
          setIcon(activeSlide, false);
        },
        { once: true }
      );
    };

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      pagination: false,
      navigation: {
        addIcons: false,
        nextEl,
        prevEl,
      },
      on: {
        init() {
          updateCurrent(this);
          playActiveSlideVideo();
        },
        slideChange() {
          updateCurrent(this);
        },
      },
    });

    swiper.wrapperEl.addEventListener('transitionend', () => {
      requestAnimationFrame(() => {
        playActiveSlideVideo();
      });
    });
  };

  const initPlayPause = () => {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-pause-button]');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      const slide = button.closest('.swiper-slide');
      const featured = button.closest(FEATURED_IMAGE_SELECTOR);
      const scope = slide || featured;

      if (!scope) return;

      const video = scope.querySelector('video');
      if (!video) return;

      if (video.paused) {
        if (slide) {
          slide.dataset.userPaused = 'false';
        }

        safePlay(video, () => {
          setIcon(scope, true);
        });
      } else {
        if (slide) {
          slide.dataset.userPaused = 'true';
        }

        video.pause();
        setIcon(scope, false);
      }
    });
  };

  const playFirstDesktopVideo = () => {
    const firstVideo = document.querySelector(
      `${PRODUCT_SELECTOR} ${FEATURED_IMAGE_SELECTOR} video`
    );

    if (!firstVideo) return;

    safePlay(firstVideo, () => {
      const wrapper = firstVideo.closest(FEATURED_IMAGE_SELECTOR);
      setIcon(wrapper, true);
    });
  };

  const init = () => {
    initThumbnails();
    initSwipers();
    initPlayPause();
    playFirstDesktopVideo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();